
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class OrderBOMGrid extends Serenity.EntityGrid<OrderBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.OrderBOM'; }
        protected getDialogType() { return OrderBOMDialog; }
        protected getIdProperty() { return OrderBOMRow.idProperty; }
        protected getInsertPermission() { return OrderBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderBOMRow.localTextPrefix; }
        protected getService() { return OrderBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}